export enum IconName {
  BUS = 'bus',
  AIRCRAFT_HORIZONTAL = 'aircraft-horizontal',
  SUSTAINABILITY_BALL = 'sustainability-block',
  SUSTAINABILITY = 'sustainability',
  INFO = 'info-block',
  INFO_OUTLINE = 'info-outline',
  CHECKMARK = 'checkmark-block',
  ALERT_TRIANGLE = 'alert-triangle-block',
  REMOVE = 'close-delete-block',
  SAF = 'saf',
}
